<template>

<div class="title">

    <div class="title-text">{{ text }}</div>

</div>

</template>

<script>

export default {

    props: ['text']

}

</script>

<style scoped>

.title {
    padding: 10px 20px;
    margin-top: 20px;
}

.title:first-child {
    margin-top: 0px;
}

.title-text {
    font-size: 12px;
    text-transform: uppercase;
    color: #fff;
    font-weight: 300;
    letter-spacing: 2px;
}

</style>
